import * as React from 'react';

import SearchFrame from 'bundles/search-common/components/SearchFrame';
import { FILTER_TYPE, PAGINATION_TYPE } from 'bundles/search-common/constants/filter';
import useIsEqp from 'bundles/search-common/utils/useIsEqp';

export const SearchFrameRenderer = () => {
  const isSEOEntityPage = useIsEqp();

  return (
    <SearchFrame
      config={{
        paginationType: PAGINATION_TYPE.PAGINATED,
        enableFilters: true,
        filterType: FILTER_TYPE.INLINE,
        showSortBy: true,
        showRelatedQueries: true,
        showCplusUpsell: true,
        isSEOEntityPage,
        enableFeaturedSnippet: false,
        enableSchemaMarkup: isSEOEntityPage,
        enableSEOMetatags: isSEOEntityPage,
        enableScrollToResultsOnPageChange: true,
      }}
    />
  );
};
